import React, { useState } from 'react';
import { useField } from 'formik';
import { Button, Text } from '@chakra-ui/react';

interface Props {
    text?: string;
    topMargin?: string;
    align?: 'right' | 'left';
}

const RadioField = ({ ...props }: any) => {
    const [field, meta, helpers] = useField(props.name);
    const { setValue } = helpers;
    const { value } = meta;

    const [isSelected, setIsSelected] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const changeHandler = (e: any) => {
        if (value === props.value) {
            setValue('');
            setIsChecked(true);
        } else {
            setValue(props.value);
            setIsChecked(false);
        }
    };

    return (
        <Button
            bg="none"
            width="100%"
            // borderRadius="100px"
            borderRadius={props.align === 'left' ? '100px 0 0 100px' : props.align === 'right' ? '0 100px 100px 0' : props.align === 'center' ? '100px' : '0'}
            border="1px solid #E1E0E3"
            mt={props.topMargin ? props.topMargin : '6'}
            // outline='solid 2px red'
            onClick={changeHandler}
            outline={value === props.value ? 'solid 2px #9836ef' : 'solid 1px #E2E8F0'}
            sx={ value === props.value ? 
                    {outline: 'solid 1px #E2E8F0',
                    border: '1px solid transparent',
                    background: 'linear-gradient(white 0 0) padding-box, linear-gradient(to left, #FF53BA, #178BFF) border-box',
                    display: 'flex',
                    padding: '0 -24px' } : {outline: ''}
            }
            _hover={{}}
            fontWeight={500}
            height={props.height ? props.height : '48px'}
            onChange={(e) => {
                field.onChange(e);
                changeHandler(e);
            }}
            _selected={{
              outline: 'solid 2.5px white',
                    border: '1px solid transparent',
                    background:
                        'linear-gradient(white 0 0) padding-box, linear-gradient(to left, #FF53BA, #178BFF) border-box',
                    borderRadius: '100px',
                    display: 'flex',
                    padding: '0 -24px'
            }}
            mb={props.mb ? props.mb : '0px'}
            {...meta.error && meta.touched ? () => props.handleError : {}}
        >

            {meta.touched && meta.error ? <Text>{props.text}<br /><Text fontSize='8px' color='red'>{meta.error}</Text></Text> : <Text>{props.text}</Text>}
        </Button>
    );
};

export default RadioField;
